import React from 'react';
import {
  Button,
  Image,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import DraggableFlatList from 'react-native-draggable-flatlist';

import { DraggableSheet } from '../reusable/DraggableSheet';
import { RouteType } from 'types/map';

const handleIcon = require('assets/handle.svg');

const testID = 'RoutesPopup';

function calculateTime(duration: { hours: number; minutes: number }) {
  const hours = duration?.hours ? `${duration?.hours}h` : '';
  const minutes = duration?.minutes ? `${duration?.minutes}m` : '';

  return `${hours}${minutes}`;
}

export function RoutesPopup({
  route,
  close,
  setDestinations,
  open = false,
}: {
  route: RouteType;
  close: () => void;
  setDestinations: (segments) => void;
  open?: boolean;
}) {
  const renderItem = ({ item, drag, isActive, getIndex }) => {
    const { distance, duration, name } = item;
    const index = getIndex();
    const prevTitle =
      index > 0 ? route?.segments[index - 1].name || `Point ${index}` : 'Start';
    const currentTitle = name || `Point ${index + 1}`;

    return (
      <TouchableOpacity
        onLongPress={drag}
        disabled={isActive}
        style={[styles.itemContainer, isActive ? styles.activeItem : null]}
      >
        <Image source={handleIcon} style={styles.handle} />
        <View key={currentTitle}>
          <Text style={styles.subtitle}>
            {prevTitle} to {currentTitle}
          </Text>
          <Text style={styles.text}>Distance: {distance}mi</Text>
          <Text style={styles.text}>
            Estimated duration: {calculateTime(duration)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };
  return (
    <DraggableSheet
      dismiss={close}
      testID={testID}
      open={open}
      id="routesPopup"
    >
      <View>
        <View style={styles.titleSection}>
          <Text style={styles.title}>Current Route</Text>
          <Text style={styles.titleText}>
            Total distance: {route?.distance}
          </Text>
          <Text style={styles.titleText}>
            Total estimated duration: {calculateTime(route?.duration)}
          </Text>
        </View>
        {route?.segments?.length > 1 && (
          <DraggableFlatList
            data={route?.segments}
            renderItem={renderItem}
            onDragEnd={({ data }) => setDestinations(data)}
            keyExtractor={(item) => item.name}
          />
        )}
        <Button
          title="Clear"
          onPress={() => {
            setDestinations(null);
            close();
          }}
        />
      </View>
    </DraggableSheet>
  );
}

const styles = StyleSheet.create({
  itemContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    borderTopColor: '#e6e6e6',
    borderTopWidth: 1,
    paddingVertical: 10,
  },
  titleSection: {
    marginBottom: 10,
  },
  title: {
    fontSize: 25,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  titleText: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  text: {
    fontSize: 16,
  },
  button: {
    position: 'absolute',
    top: -30,
    right: 10,
  },
  subtitle: {
    fontSize: 20,
  },
  activeItem: {
    shadowRadius: 20,
    shadowOpacity: 0.5,
    shadowOffset: { width: 0, height: 5 },
  },
  handle: {
    width: 30,
    height: 30,
    marginRight: 10,
  },
});
